'use client';
import { createContext, useContext } from 'react';
const noopComposerEditorControls = Object.freeze({
    append: () => false,
    focus: () => { },
    isReady: false,
    replaceSuffixOrAppend: () => false,
    subscribeUserTakeover: () => () => { },
});
export const ComposerEditorContext = createContext(noopComposerEditorControls);
ComposerEditorContext.displayName = 'ComposerEditorContext';
export function useComposerEditor() {
    return useContext(ComposerEditorContext);
}
//# sourceMappingURL=ComposerEditorContext.js.map